export interface TableHeaderSortItemtype {
  name: string;
  type: TableHeaderSortItemTypeEnum;
}

export enum TableHeaderSortItemTypeEnum {
  DESC = "desc",
  ASC = "asc",
}
